import { m8API } from 'services/production/m8';
import { GetPromocodesPageDataService } from 'types/services';
import { normalizePromocodesTableSortableField } from '../utils/normalizePromocodesTableSortableField';
import { normalizeM8Promocode } from '../utils/normalizeM8Promocode';

export const getPromocodesPageData: GetPromocodesPageDataService = async (
  params
) => {
  const order = (() => {
    if (params.sorting.field === 'status') {
      return params.sorting.ascending ? 'DESC' : 'ASC';
    } else {
      return params.sorting.ascending ? 'ASC' : 'DESC';
    }
  })();

  const m8PagedResponse = await m8API.admin.getPromocodes({
    page: params.page - 1,
    size: params.pageSize,
    sort: normalizePromocodesTableSortableField(
      params.sorting.field
    ).toM8PromocodeSortableField(),
    order,
    startWith: params.searchBy || '',
  });

  if (m8PagedResponse) {
    return {
      totalPagesCount: m8PagedResponse.totalPages,
      promocodes: m8PagedResponse.content.map((m8Promocode) =>
        normalizeM8Promocode(m8Promocode).toPromocode()
      ),
    };
  }

  return {
    totalPagesCount: 0,
    promocodes: [],
  };
};
